<div class="auth-title-text-pb">{{ loginTitle$ | async }}</div>

<form [formGroup]="formGroup" class="d-flex flex-column gap-4 mb-4">
  <div class="d-flex flex-column gap-2">
    <label for="email" class="form-input-label" i18n>Email</label>
    <app-email-input
      formControlName="email"
      controlId="email"
      [error]="formSubmitted && formGroup.controls.email.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.email.invalid"
      [errors]="formGroup.controls.email.errors" />
  </div>

  <div class="d-flex flex-column gap-2">
    <label for="password" class="form-input-label" i18n>Password</label>
    <app-password-input
      formControlName="password"
      controlId="password"
      (keydown.enter)="submit()"
      [error]="formSubmitted && formGroup.controls.password.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.password.invalid"
      [errors]="formGroup.controls.password.errors" />
  </div>
</form>

<div *ngIf="!(isEmployerPortal$ | async)" class="action-button-container">
  <button class="paddingless-text-button" type="button" i18n (click)="navigateToForgotPassword()">
    Forgot your password?
  </button>
  <app-primary-button
    class="member-login-submit"
    [style.width]="'100%'"
    i18n
    (buttonClicked)="submit()"
    [width]="'100%'">
    Log In
  </app-primary-button>
  <ng-container *ngIf="isMemberPortal$ | async">
    <app-tertiary-button
      class="member-enrol-action"
      (buttonClicked)="goToMemberSelfEnrolment()"
      [size]="BaseButtonSizeEnum.sm"
      [style.width]="'100%'"
      i18n
      [width]="'100%'">
      Not a Member Yet? Join Today!
    </app-tertiary-button>
  </ng-container>
</div>

<div *ngIf="isEmployerPortal$ | async" class="d-flex flex-column align-items-baseline" [style.gap.rem]="2">
  <button class="paddingless-text-button" type="button" i18n (click)="navigateToForgotPassword()">
    Forgot your password?
  </button>
  <div class="d-flex flex-column w-100" [style.gap.rem]="2.5">
    <app-primary-button
      [size]="BaseButtonSizeEnum.md"
      [style.width]="'100%'"
      i18n
      (buttonClicked)="submit()"
      [width]="'100%'">
      Log In
    </app-primary-button>
    <div class="d-flex gap-3 align-items-center">
      <div class="or-divider-line"></div>
      <div class="or-text" i18n>or</div>
      <div class="or-divider-line"></div>
    </div>
    <app-secondary-button
      [size]="BaseButtonSizeEnum.md"
      [style.width]="'100%'"
      [width]="'100%'"
      (buttonClicked)="goToEmployerSelfEnrolment()"
      i18n
      >Register as a New Employer</app-secondary-button
    >
  </div>
</div>
